<template>
  <div class="content">
    <div class="list" v-for="(item, index) in arrContent" :key="index">
      <div
        class="multigraph"
        v-if="item.type != 3"
        @click="goNavto(item.type, item.materal)"
      >
        <div class="multigraph-title">
          <div class="text">{{ item.title }}</div>
          <div class="bottom">
            <div>{{ item.type_title }}</div>
            <div class="hot">
              <img src="@/assets/images/ant/details/hot.png" alt="" />
              <div>{{ item.read_num }}</div>
            </div>
          </div>
        </div>
        <div class="multigraph-cover">
          <img :src="item.pic" alt="" />
        </div>
      </div>
      <div class="video" v-if="item.type == 3" @click="goNavto(item.type, item.materal)">
        <div class="video-title">{{ item.keywords }}</div>
        <div class="video-content">
          <img :src="item.pic" alt="" />
        </div>
        <div class="bottom">
          <div>{{ item.type_title }}</div>
          <div class="hot">
            <img src="@/assets/images/ant/details/hot.png" alt="" />
            <div>{{ item.read_num }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {requestAesPost5} from '@/libsV2/requestAes.js'
import detail from "@/js/detail.js";
export default {
  components: {},
  data() {
    return {
      arrContent: [], //内容
    };
  },
  created() {
    let that = this;
    let id = that.$route.query.id;
    this.getContents(id);
  },
  methods: {
    goNavto(type, materal) {
      this.$router.push({
        path: `/contentdetails/index?materal=${materal}`,
      });
    },
    getContents(id) {
      let that = this;
      this.$store.commit("loadSwitch", true);
      requestAesPost5('shop/goods/contents',{ id: id }).then((res) => {
        //  console.log(res);
        let arrContent = res.data.data.result;
        this.$store.commit("loadSwitch", false);
        arrContent.forEach((res) => {
          switch (res.type) {
            case 1:
              res.type_title = "图文";
              break;
            case 2:
              res.type_title = "图片";
              break;
            case 3:
              res.type_title = "视频";
              break;
            case 4:
              res.type_title = "外链";
              break;
            case 5:
              res.type_title = "公众号";
              break;
            case 6:
              res.type_title = "朋友圈";
              break;
            case 7:
              res.type_title = "音频";
          }
        });
        that.arrContent = arrContent;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  background-color: #fff;
  min-height: 100vh;
  padding: 30px;
  box-sizing: border-box;
}
.multigraph {
  display: flex;
  padding: 30px 0px;
  box-sizing: border-box;
  border-top: 1px solid #f7f8fa;
  .multigraph-title {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .text {
      font-size: 30px;
      font-weight: bold;
      text-align: justify;
    }
    .bottom {
      color: #a3a4a6;
      font-size: 24px;
      padding: 5px 0px;
      box-sizing: border-box;
      display: flex;
      .hot {
        display: flex;
        align-items: center;
        margin-left: 20px;
        img {
          margin-right: 8px;
          width: 35px;
          height: 35px;
        }
      }
    }
  }
  .multigraph-cover {
    margin-left: 30px;
    flex-shrink: 0;
    img {
      width: 184px;
      height: 184px;
      border-radius: 12px;
    }
  }
}
.video {
  padding: 30px 0px;
  box-sizing: border-box;
  border-top: 1px solid #f7f8fa;
  .video-title {
    font-size: 30px;
    font-weight: bold;
  }
  .video-content {
    margin-top: 20px;
    img {
      width: 100%;
      height: 420px;
      border-radius: 5px;
    }
  }
  .bottom {
    color: #a3a4a6;
    font-size: 24px;
    padding: 5px 0px;
    box-sizing: border-box;
    display: flex;
    .hot {
      display: flex;
      align-items: center;
      margin-left: 20px;
      img {
        margin-right: 8px;
        width: 35px;
        height: 35px;
      }
    }
  }
}
</style>
